export default __webpack_public_path__ + "static/media/mobilePhone.e740c910.png";